import axios from "@/libs/api.request";

export const login = ({ userName, password }) => {
  const data = {
    email: userName,
    password
  };
  return axios.request({
    url: "auth/login",
    data,
    method: "post"
  });
};

export const getUserInfo = token => {
  return axios.request({
    url: "auth/me",
    params: {},
    method: "post"
  });
};

export const logout = token => {
  return axios.request({
    url: "auth/logout",
    method: "post"
  });
};

export const userInfo = () => {
  return axios.request({
    url: "auth/userInfo",
    method: "post"
  });
};

export const updatePasswd = (oldpwd, newpwd) => {
  return axios.request({
    url: "auth/updatePasswd",
    data: { oldpwd, newpwd },
    method: "post"
  });
};

export const updateProfile = data => {
  return axios.request({
    url: "auth/updateProfile",
    data: data,
    method: "post"
  });
};
